import React from 'react';

const DienteSVG = ({ numero, estado, onSectorClick, style = {} }) => {
    // estado: { 
    //   sectores: { ... }, 
    //   condicion: '...',
    //   atributos: { corona: '...', endodoncia: '...', provisional: '...', implante: '...', sellante: '...', nucleo: '...' }
    // }

    // Generamos IDs únicos para los patrones
    const patIdAzul = `resina_azul_${numero}`;
    const patIdRojo = `resina_roja_${numero}`;

    const getColor = (sector) => {
        const estadoSector = estado?.sectores ? estado.sectores[sector] : null;
        switch (estadoSector) {
            case 'caries': return '#dc3545'; // Rojo
            case 'retraccion_gingival': return '#fd7e14'; // Naranja (mismo comportamiento que caries por sector)
            case 'obturacion': return '#007bff'; // Azul
            case 'resina_presente': return `url(#${patIdAzul})`; // Trama Azul
            case 'resina_indicada': return `url(#${patIdRojo})`; // Trama Roja
            case 'carilla_presente': return `url(#carilla_azul_${numero})`; // Trama Vertical Azul
            case 'carilla_desadaptada': return `url(#carilla_roja_${numero})`; // Trama Vertical Roja
            case 'sellante': return '#28a745'; // Verde
            default:
                if (['pontico', 'pilar_izquierdo', 'pilar_derecho'].includes(estado?.condicion)) {
                    return 'green';
                }
                return 'white';
        }
    };

    const paths = {
        arriba: "M0,0 L100,0 L65,35 L35,35 Z",
        abajo: "M0,100 L100,100 L65,65 L35,65 Z",
        izquierda: "M0,0 L0,100 L35,65 L35,35 Z",
        derecha: "M100,0 L100,100 L65,65 L65,35 Z",
        centro: "M35,35 L65,35 L65,65 L35,65 Z"
    };

    const renderOverlays = () => {
        const elements = [];

        // --- Condición General ---
        if (estado?.condicion === 'extraccion') {
            // Línea vertical roja (Diente Extraído)
            elements.push(<line key="extraido" x1="50" y1="0" x2="50" y2="100" stroke="red" strokeWidth="6" style={{ pointerEvents: 'none' }} />);
        } else if (estado?.condicion === 'ausente') {
            // Línea vertical negra (Diente Ausente)
            elements.push(<line key="ausente" x1="50" y1="0" x2="50" y2="100" stroke="black" strokeWidth="6" style={{ pointerEvents: 'none' }} />);
        } else if (estado?.condicion === 'exodoncia_indicada') {
            // X ROJA GRANDE (Exodoncia Indicada)
            elements.push(
                <g key="exodoncia_indicada" style={{ pointerEvents: 'none' }}>
                    <line x1="10" y1="10" x2="90" y2="90" stroke="red" strokeWidth="6" />
                    <line x1="90" y1="10" x2="10" y2="90" stroke="red" strokeWidth="6" />
                </g>
            );
        } else if (estado?.condicion === 'sano') {
            elements.push(<text key="sano" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fill="blue" fontWeight="bold" style={{ pointerEvents: 'none', opacity: 0.8 }}>✔</text>)
        } else if (estado?.condicion === 'pontico') {
            // Línea vertical roja
            elements.push(<line key="pontico_v" x1="50" y1="0" x2="50" y2="100" stroke="red" strokeWidth="6" style={{ pointerEvents: 'none' }} />);
            // Líneas horizontales negras (Izquierda y Derecha)
            elements.push(<line key="pontico_l1" x1="0" y1="45" x2="15" y2="45" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
            elements.push(<line key="pontico_l2" x1="0" y1="55" x2="15" y2="55" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
            elements.push(<line key="pontico_r1" x1="85" y1="45" x2="100" y2="45" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
            elements.push(<line key="pontico_r2" x1="85" y1="55" x2="100" y2="55" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
        } else if (estado?.condicion === 'pilar_izquierdo') {
            // Líneas horizontales negras (Solo Izquierda)
            elements.push(<line key="pil_izq_1" x1="0" y1="45" x2="15" y2="45" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
            elements.push(<line key="pil_izq_2" x1="0" y1="55" x2="15" y2="55" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
        } else if (estado?.condicion === 'pilar_derecho') {
            // Líneas horizontales negras (Solo Derecha)
            elements.push(<line key="pil_der_1" x1="85" y1="45" x2="100" y2="45" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
            elements.push(<line key="pil_der_2" x1="85" y1="55" x2="100" y2="55" stroke="black" strokeWidth="4" style={{ pointerEvents: 'none' }} />);
        }

        // --- Atributos/Tratamientos ---

        // CORONAS
        if (estado?.atributos?.corona === 'presente') {
            elements.push(<circle key="cop" cx="50" cy="50" r="35" stroke="blue" strokeWidth="3" fill="none" style={{ pointerEvents: 'none' }} />);
        } else if (estado?.atributos?.corona === 'desadaptada') {
            elements.push(<circle key="cod" cx="50" cy="50" r="35" stroke="red" strokeWidth="3" fill="none" style={{ pointerEvents: 'none' }} />);
        }

        // ENDODONCIA (Triángulo outline)
        if (estado?.atributos?.endodoncia) {
            const isSuperior = (numero >= 11 && numero <= 28) || (numero >= 51 && numero <= 65);
            const color = estado.atributos.endodoncia === 'realizada' ? 'blue' : 'red';
            const key = estado.atributos.endodoncia === 'realizada' ? 'endr' : 'endi';

            // Superior: Apice abajo (▽), Inferior: Apice arriba (△)
            const pathData = isSuperior
                ? "M20,15 L80,15 L50,85 Z"
                : "M50,15 L20,85 L80,85 Z";

            elements.push(<path key={key} d={pathData} fill="none" stroke={color} strokeWidth="3" style={{ pointerEvents: 'none' }} />);
        }

        // NUCLEO (Triángulo invertido sólido)
        if (estado?.atributos?.nucleo === 'presente') {
            elements.push(<path key="nucp" d="M25,95 L75,95 L50,55 Z" fill="green" stroke="green" strokeWidth="1" style={{ pointerEvents: 'none', opacity: 0.6 }} />);
        } else if (estado?.atributos?.nucleo === 'indicado') {
            elements.push(<path key="nuci" d="M25,95 L75,95 L50,55 Z" fill="red" stroke="red" strokeWidth="1" style={{ pointerEvents: 'none', opacity: 0.6 }} />);
        }

        // PROVISIONALES
        if (estado?.atributos?.provisional === 'presente') {
            elements.push(<text key="prp" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fontWeight="bold" fill="blue" style={{ pointerEvents: 'none', textShadow: '0 0 2px white' }}>P</text>);
        } else if (estado?.atributos?.provisional === 'indicado') {
            elements.push(<text key="pri" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fontWeight="bold" fill="red" style={{ pointerEvents: 'none', textShadow: '0 0 2px white' }}>P</text>);
        }

        // IMPLANTES
        if (estado?.atributos?.implante === 'integrado') {
            elements.push(<text key="imi" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fontWeight="bold" fill="blue" style={{ pointerEvents: 'none', textShadow: '0 0 2px white' }}>I</text>);
        } else if (estado?.atributos?.implante === 'no_integrado') {
            elements.push(<text key="imn" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fontWeight="bold" fill="red" style={{ pointerEvents: 'none', textShadow: '0 0 2px white' }}>I</text>);
        }

        // SELLANTES
        if (estado?.atributos?.sellante === 'presente') {
            elements.push(<text key="sep" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fontWeight="bold" fill="blue" style={{ pointerEvents: 'none', textShadow: '0 0 2px white' }}>S</text>);
        } else if (estado?.atributos?.sellante === 'indicado') {
            elements.push(<text key="sei" x="50" y="50" textAnchor="middle" dy=".3em" fontSize="60" fontWeight="bold" fill="red" style={{ pointerEvents: 'none', textShadow: '0 0 2px white' }}>S</text>);
        }

        // BRACKETS
        if (estado?.atributos?.brackets === 'presente') {
            elements.push(
                <g key="brk" style={{ pointerEvents: 'none' }}>
                    {/* Línea horizontal que atraviesa */}
                    <line x1="10" y1="50" x2="90" y2="50" stroke="red" strokeWidth="4" />
                    {/* Cuadrado central relleno de rojo con borde blanco opcional para contraste */}
                    <rect x="35" y="35" width="30" height="30" fill="red" stroke="red" strokeWidth="2" />
                    {/* Pequeño detalle blanco dentro para asemejar el slot del bracket si se desea, o dejar solido */}
                    <rect x="42" y="45" width="16" height="10" fill="white" />
                </g>
            );
        }

        // ROTACIONES Y MIGRACIONES
        if (estado?.atributos?.rotacion === 'presente') {
            elements.push(
                <g key="rot" style={{ pointerEvents: 'none' }}>
                    {/* Flecha Superior (Hacia la Izquierda) */}
                    <line x1="5" y1="68" x2="95" y2="68" stroke="blue" strokeWidth="3" />
                    <polyline points="15,63 5,68 15,73" fill="none" stroke="blue" strokeWidth="3" />

                    {/* Flecha Inferior (Hacia la Derecha) */}
                    <line x1="5" y1="76" x2="95" y2="76" stroke="blue" strokeWidth="3" />
                    <polyline points="85,71 95,76 85,81" fill="none" stroke="blue" strokeWidth="3" />
                </g>
            );
        }

        return elements;

    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '2px', ...style }}>
            <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#555', marginBottom: '1px' }}>{numero}</span>
            <svg width="36" height="36" viewBox="0 0 100 100" style={{ cursor: 'pointer', border: '1px solid #ddd', backgroundColor: '#fff', borderRadius: '4px' }}>
                <defs>
                    <pattern id={patIdAzul} patternUnits="userSpaceOnUse" width="10" height="10">
                        <rect width="10" height="10" fill="white" />
                        <path d="M0,10 L10,0 M-2,2 L2,-2 M8,12 L12,8" stroke="blue" strokeWidth="2" />
                        <path d="M0,0 L10,10 M-2,8 L2,12 M8,-2 L12,2" stroke="blue" strokeWidth="2" />
                    </pattern>
                    <pattern id={patIdRojo} patternUnits="userSpaceOnUse" width="10" height="10">
                        <rect width="10" height="10" fill="white" />
                        <path d="M0,10 L10,0 M-2,2 L2,-2 M8,12 L12,8" stroke="red" strokeWidth="2" />
                        <path d="M0,0 L10,10 M-2,8 L2,12 M8,-2 L12,2" stroke="red" strokeWidth="2" />
                    </pattern>
                    <pattern id={`carilla_azul_${numero}`} patternUnits="userSpaceOnUse" width="6" height="6">
                        <line x1="3" y1="0" x2="3" y2="6" stroke="blue" strokeWidth="2" />
                    </pattern>
                    <pattern id={`carilla_roja_${numero}`} patternUnits="userSpaceOnUse" width="6" height="6">
                        <line x1="3" y1="0" x2="3" y2="6" stroke="red" strokeWidth="2" />
                    </pattern>
                </defs>

                <rect x="0" y="0" width="100" height="100" fill="#fff" />

                <path d={paths.arriba} fill={getColor('arriba')} stroke="#adb5bd" strokeWidth="1" onClick={() => onSectorClick(numero, 'arriba')} />
                <path d={paths.abajo} fill={getColor('abajo')} stroke="#adb5bd" strokeWidth="1" onClick={() => onSectorClick(numero, 'abajo')} />
                <path d={paths.izquierda} fill={getColor('izquierda')} stroke="#adb5bd" strokeWidth="1" onClick={() => onSectorClick(numero, 'izquierda')} />
                <path d={paths.derecha} fill={getColor('derecha')} stroke="#adb5bd" strokeWidth="1" onClick={() => onSectorClick(numero, 'derecha')} />
                <path d={paths.centro} fill={getColor('centro')} stroke="#adb5bd" strokeWidth="1" onClick={() => onSectorClick(numero, 'centro')} />

                {renderOverlays()}
            </svg>
        </div>
    );
};

export default DienteSVG;
